import styled from 'styled-components'
import { colors, breakpoints, fontWeights } from '@/styles'

export const Wrapper = styled.div`
  background: ${colors.white};
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  max-height: 98vh;
  max-width: 767px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    max-height: unset;
    border-radius: 16px 16px 0 0;
  }
`

export const ModalClose = styled.div`
  position: absolute;
  top: 29px;
  right: 37px;
  z-index: 1;

  svg {
    cursor: pointer;
    margin: 0;
  }

  :hover {
    opacity: 0.7;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    top: 20px;
    right: 20px;
  }
`

export const ScrollWrapper = styled.div`
  background: ${colors.white};
  height: 100%;
  max-height: 740px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-shrink: 0;
  padding: 0px 32px 35px;
  overflow-y: scroll;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    height: calc(100% - 160px);
    padding: 0px 32px 0px;
    flex-direction: column;
    overflow-y: scroll;
    justify-content: flex-start;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0px 24px 0px;
  }
`

export const ContentWrapper = styled.div`
  background: ${colors.white};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 0px 32px 35px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    justify-content: flex-start;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0px 24px 24px;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  padding: 0 32px;
  justify-content: space-between;
  align-items: center;
  margin: ${({ isDesktop }) => (isDesktop ? '60px 0 24px' : '0px 0 24px')};
  width: 100%;
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 0 24px;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Title = styled.span`
  font-weight: ${fontWeights.bold};
  line-height: 32px;
  font-size: 24px;
  color: ${colors.grey16};
  margin-right: 10px;
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin-right: 0;
    font-size: 18px;
    font-weight: ${fontWeights.medium};
  }
`

export const PoweredByText = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey16};
  margin-right: 10px;
  white-space: nowrap;
`

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey24};
  margin: 0;
  padding: ${({ padding }) => (padding ? padding : '0px')};
  width: 100%;
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '0px')};
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 14px;
    line-height: 20px;
  }
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${colors.grey88};
  margin-bottom: 12px;
`

export const Subheader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 12px;
  font-size: 14px;
  color: ${colors.grey16};
  font-weight: ${fontWeights.medium};
  background-color: ${colors.background};
  border-bottom: 1px solid ${colors.grey88};
`

export const Link = styled.a`
  color: ${colors.link};
  font-size: 16px;
  text-decoration: none;
  font-weight: ${fontWeights.medium};
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 14px;
  }
`
export const EquifaxContainer = styled.div`
  display: flex;
  width: 245px;
  color: ${colors.grey16};
  font-size: 14px;
  margin-right: 20px;
  svg {
    margin-left: 10px;

    width: 130px;
  }

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    width: auto;
    font-size: 12px;

    svg {
      margin-left: 10px;
      width: 90px;
    }
  }
`
export const TrustScoreTable = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`
export const MobileTableWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  margin-bottom: 24px;
`
export const TrustScoreRow = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 18px;
  grid-template-columns:
    minmax(min-content, 90px) minmax(min-content, 90px) minmax(min-content, 90px)
    minmax(90px, max-content);
  padding: 10px;
  border-radius: ${({ isHeader }) => (isHeader ? '6px 6px 0 0' : '0')};
  border-bottom: ${({ isHeader }) =>
    isHeader ? `2px solid ${colors.grey88}` : `1px solid ${colors.grey88}`};
  background-color: ${({ isGrey, isHeader }) =>
    isGrey || isHeader ? colors.grey96 : colors.white};
`
export const MobileRow = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 18px;
  grid-template-columns: minmax(min-content, 90px) minmax(90px, max-content);
  padding: 10px;
`
export const ColumnHeader = styled.span`
  font-weight: ${fontWeights.bold};
  font-size: 14px;
  color: ${colors.grey16};
`
export const RowHeader = styled(ColumnHeader)``
export const TableText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 23px;
  color: ${colors.grey16};
  overflow-wrap: break-word;
`
export const MobileRowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  > :nth-child(even) {
    background: ${colors.background};
  }
  > * {
    border-bottom: 1px solid ${colors.grey88};
    padding: 12px;
  }
`
